import React from 'react';
import { motion } from 'framer-motion';
export function ConsciousnessMessage() {
  return <section id="seccion-conciencia" className="w-full bg-gradient-to-b from-sky-light to-mint-light py-20 px-6" data-id="element-27">
      <div className="max-w-2xl mx-auto text-center" data-id="element-28">
        <motion.blockquote initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="font-playfair text-xl md:text-2xl lg:text-3xl font-semibold text-dark-text leading-relaxed mb-8" data-id="element-29">
          "Las pantallas no son el problema. El problema es cuando reemplazan la
          presencia, el diálogo y los límites."
        </motion.blockquote>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="font-lato text-base md:text-lg text-medium-text leading-relaxed mb-8 max-w-xl mx-auto" data-id="element-30">
          Este ebook no busca demonizar la tecnología. Busca ayudarte a
          recuperar el control, proteger el desarrollo emocional de tu hijo y
          volver a poner a la familia en el centro.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="font-playfair text-lg md:text-xl font-bold text-dark-text mb-10" data-id="element-31">
          Hoy todavía estás a tiempo.
        </motion.p>

        <motion.a href="#cta-final" id="cta-conciencia" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.6
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-block bg-red-cta text-white font-lato font-semibold text-base md:text-lg px-8 py-4 rounded-lg shadow-lg hover:bg-red-700 transition-colors duration-200" data-id="element-32">
          QUIERO RECUPERAR LA CALMA EN CASA
        </motion.a>
      </div>
    </section>;
}